import { ErrorView, Heading1, Paragraph2, SmallText, Button } from 'inpock-ui-react';
import styled from '@emotion/styled';

import { openPopup } from '@/utils';

interface ErrorTemplateProps {
  status?: number;
  msg?: string;
}

const StyledErrorMsg = styled.div`
  background-color: var(--color-ui-grayscale-gray-100);
  padding: 12px;
  margin-bottom: 12px;
`;

export function ErrorTemplate({ status, msg }: ErrorTemplateProps) {
  const onClickKakao = () => {
    openPopup('https://inpocklink.channel.io/home', 375, 812);
  };

  const onClickLink = () => {
    location.href = 'https://link.inpock.co.kr';
  };

  return (
    <ErrorView
      emojii="😱"
      header={
        <Heading1>
          <span className="color-error">문제</span>가 발생했습니다{' '}
        </Heading1>
      }
      description={
        <>
          {msg && (
            <StyledErrorMsg>
              <SmallText>{msg}</SmallText>
            </StyledErrorMsg>
          )}
          <Paragraph2>
            새로고침을 하거나 잠시 후 다시 이용해주세요
            <br />
            여전히 문제가 발생할 경우 오류를 알려주시면 <br />
            최대한 빠르게 해결하겠습니다
          </Paragraph2>
        </>
      }
      cta={
        <>
          <Button size="large" type="primary" fullWidth onClick={onClickKakao}>
            인포크 팀에게 오류 알려주기
          </Button>
          <Button size="large" type="secondary" fullWidth onClick={onClickLink}>
            인포크링크 홈페이지
          </Button>
        </>
      }
    ></ErrorView>
  );
}
